import React from 'react';
import { cn } from '@/lib/utils';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Complete Bridal Packages",
      description: "Comprehensive beauty packages for the bride's special day, including makeup, hairstyling, and treatments.",
      image: "/images/services/bridal-package.jpg",
    },
    {
      id: 2,
      title: "Bridal Makeup & Hairstyle",
      description: "Professional makeup and hairstyling services specifically designed for brides.",
      image: "/images/services/bridal-makeup.jpg",
    },
    {
      id: 3,
      title: "Party Makeup & Hairstyle",
      description: "Glamorous makeup and hairstyling for special occasions and parties.",
      image: "/images/services/party-makeup.jpg",
    },
    {
      id: 4,
      title: "Facial Treatment",
      description: "Rejuvenating facial treatments to cleanse, exfoliate, and nourish your skin.",
      image: "/images/services/facial.jpg",
    },
    {
      id: 5,
      title: "Haircut & Styling",
      description: "Professional haircuts and styling services tailored to your preferences.",
      image: "/images/services/haircut.jpg",
    },
    {
      id: 6,
      title: "Hair Treatments",
      description: "Nourishing hair treatments to repair damage and promote healthy hair growth.",
      image: "/images/services/hair-treatment.jpg",
    },
    {
      id: 7,
      title: "Nails Art",
      description: "Creative nail art and manicure services to enhance your hands and feet.",
      image: "/images/services/nail-art.jpg",
    },
    {
      id: 8,
      title: "Basic Parlour Courses",
      description: "Introductory courses for those interested in learning basic beauty techniques.",
      image: "/images/services/basic-course.jpg",
    },
    {
      id: 9,
      title: "Professional Parlour Courses",
      description: "Advanced courses for aspiring beauty professionals seeking certification.",
      image: "/images/services/pro-course.jpg",
    },
  ];

  return (
    <section id="services" className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12 reveal">
          <h2 className="text-3xl md:text-4xl font-bold text-beauty-rose mb-4">Our Premium Services</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover our range of beauty services designed to enhance your natural beauty and boost your confidence.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.id} className="reveal">
              <div className="bg-white rounded-lg shadow-md overflow-hidden h-full flex flex-col service-card">
                <div className="aspect-w-16 aspect-h-9 bg-beauty-pink/20">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 flex-grow">
                  <h3 className="text-xl font-bold text-beauty-rose mb-2">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <a 
                    href="#contact" 
                    className="text-beauty-rose hover:text-beauty-pink font-medium transition-colors inline-flex items-center"
                  >
                    Learn More
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
